import { transform } from '../../../lib/transform';
import { IGraphicSymbolProductProperties } from './i-graphic-symbol-product-properties';
import { TagManagerProductDto } from './tag-manager-product.dto';

export function buildGraphicSymbolProduct(
  properties: IGraphicSymbolProductProperties,
): TagManagerProductDto {
  return transform(TagManagerProductDto, {
    category: properties.categories[0],
    id: properties.assetName,
    name: properties.name,
    dimension5: properties.assetType,
  });
}
